module.exports = __webpack_public_path__ + "assets/green_check-32bb8e.svg";